module.exports = __webpack_public_path__ + "img/cheeks_male_high.293bea15.png";